import React from 'react';
import PropTypes from 'prop-types';
import s from './Modal.scss';

const Modal = props => {
  const { onClose, children, styles = {} } = props;
  return (
    <div className={`${s.custome_modal} ${styles.fullCoverage_overlay}`}>
      <button onClick={onClose} className={`${styles.close}`}>
        close
      </button>
      {children}
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  styles: PropTypes.shape({}),
};
Modal.defaultProps = {
  styles: {},
};

export default Modal;
